import { render, staticRenderFns } from "./Pagenation.vue?vue&type=template&id=4d05beb3&scoped=true"
import script from "./Pagenation.vue?vue&type=script&lang=js"
export * from "./Pagenation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05beb3",
  null
  
)

export default component.exports